export interface IDropZone {
    children : any
}

export const DropZone = (props:IDropZone) => {



    const onDragOver = (e) => {
    
        //if allowed
        return; //causes interference with audio
         $('#dropZone').addClass('mr-drag-over');

    }

    const onDragOverArea = (e) => {
    


        return; //causes interference with audio



         e.preventDefault();
          e.stopPropagation();
         // e.stopImmediatePropagation();
    }

    const onDragLeaveArea = (e) => {
        
        e.preventDefault();
        e.stopPropagation();

        $('#dropZone').removeClass('mr-drag-over');

    }

    const onDropArea = (e) => {
    
        e.preventDefault();

        $('#dropZone').removeClass('mr-drag-over');

        //Show a popup to handle the file upload(s) (?)
        //Maybe a seperate component to handle the message

    }


    return <div 
            id="dropZone"
            className="mr-dropzone"
            onDragOver={onDragOver}
            >
        {props.children}
        <div className="mr-dropzone-area container" 
            onDragOver={onDragOverArea}
            onDragLeave={onDragLeaveArea}
            onDrop={onDropArea}
        >
        <div className="mr-dropzone-message">Laat het bestand los om te versturen</div>
        </div>
    </div>
   

}